// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-menu-container {
    position: relative;
    /* width: 200px;
    height: 200px;
    margin: 100px auto;
    background: "black"; */
  }

  .circular-menu {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .menu-item {
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    color: #333;
    font-weight: 500;
    cursor: pointer;
    transition: transform 0.3s ease, opacity 0.3s ease;
    opacity: 0;
  }

  .menu-label {
    font-size: 11px;
    color: #005cff;
    margin-left:4px;
  }

  .circular-menu.open .menu-item {
    opacity: 1;
  }

  .toggle-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 50%;
    background: #ffffffc9;
    color: black;
    cursor: pointer;
    z-index: 1;
  }

  .toggle-icon {
    font-size: 14px;
    transition: transform 0.3s ease;
  }

  .toggle-icon.rotate {
    transform: rotate(90deg);
  }

  @media (max-width: 440px) {
    .toggle-button {
      width: 20px;
      height: 20px;
      font-size: 12px;
      margin-left: -2px;
    }

    .toggle-icon {
      font-size: 12px;
      margin-left: -2px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Extra/CircularMenu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB;;;0BAGsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kDAAkD;IAClD,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF","sourcesContent":[".circular-menu-container {\n    position: relative;\n    /* width: 200px;\n    height: 200px;\n    margin: 100px auto;\n    background: \"black\"; */\n  }\n\n  .circular-menu {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .menu-item {\n    position: absolute;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 20px;\n    padding: 6px 10px;\n    display: flex;\n    align-items: center;\n    color: #333;\n    font-weight: 500;\n    cursor: pointer;\n    transition: transform 0.3s ease, opacity 0.3s ease;\n    opacity: 0;\n  }\n\n  .menu-label {\n    font-size: 11px;\n    color: #005cff;\n    margin-left:4px;\n  }\n\n  .circular-menu.open .menu-item {\n    opacity: 1;\n  }\n\n  .toggle-button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    height: 30px;\n    border: none;\n    border-radius: 50%;\n    background: #ffffffc9;\n    color: black;\n    cursor: pointer;\n    z-index: 1;\n  }\n\n  .toggle-icon {\n    font-size: 14px;\n    transition: transform 0.3s ease;\n  }\n\n  .toggle-icon.rotate {\n    transform: rotate(90deg);\n  }\n\n  @media (max-width: 440px) {\n    .toggle-button {\n      width: 20px;\n      height: 20px;\n      font-size: 12px;\n      margin-left: -2px;\n    }\n\n    .toggle-icon {\n      font-size: 12px;\n      margin-left: -2px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
